const locale = {
	NOTIFICATIONS: 'Benachrichtigungen',
	DISMISS_ALL_NOTIFICATIONS: 'Alle entfernen',
	MARK_ALL_READ: 'Alle als gelesen markieren',
	MARK_AS_READ: 'Als gelesen markieren',
	CLOSE: 'Schließen',
	DISMISS_NOTIFICATION: 'Entfernen',
	NO_NOTIFICATIONS: 'Aktuell keine neuen Benachrichtigungen',
	TODAY: 'Heute',
	DATE_WEEKDAY: "{{ date, eeee }}",
	DATE_MONTH: "{{ date, MMMM }}",
	NOTIFICATIONPANEL_TOOLTIP: 'Benachrichtigungen',
	LANGUAGESWITCHER_TOOLTIP: 'Sprache wechseln',
	QUICKPANEL_TOOLTIP: 'Schnellinfo',
	HELPPANEL_TOOLTIP: 'Hilfe',
	NOTLOGGEDIN: "Nicht angemeldet",
	USERMENU_PROFILE: "Mein Profil",
	USERMENU_CHANGEPASSWORD: "Passwort ändern",
	USERMENU_LOGOUT: "Ausloggen",
	DARKMODE_ACTIVATE: "Darkmode aktivieren",
	DARKMODE_DEACTIVATE: "Darkmode deaktivieren",
	SOFTWAREVERSION: "Version",
	USERMENU_RELOAD: "Neu laden",
	USERMENU_STOP_IMPERSONATION: "Imitation beenden",
	YOUNEEDHELP: "Sie benötigen Unterstützung?",
	WEAREHERETOHELP: "Wir sind gerne für Sie da",
	PHONE: "Telefon",
	PHONESUBMESSAGE: "Wir sind telefonisch für Sie erreichbar und freuen uns auf Ihren Anruf",
	OPENINGHOURS: "Montag - Freitag | 09:00 - 17:00 Uhr",
	MESSAGE: "Direktnachricht",
	MESSAGESUBMESSAGE: "Sie können uns ihr Anliegen auch direkt hier übermitteln und wir werden uns umgehend darum kümmern",
	YOURMESSAGE: "Ihr Anliegen an uns",
	SEND: "Absenden",
	VIEWCHANGELOG: "Änderungsprotokoll anzeigen",
	IMPORTANCE: "Wichtigkeit",
	IMPORTANCE_LOWEST: "Am niedrigsten",
	IMPORTANCE_LOWER: "Niedriger",
	IMPORTANCE_LOW: "Niedrig",
	IMPORTANCE_NORMAL: "Normal",
	IMPORTANCE_HIGH: "Hoch",
	IMPORTANCE_HIGHER: "Höher",
	IMPORTANCE_HIGHEST: "Am höchsten",
	NOTIFICATION_SETTINGS: "Benachrichtigungseinstellungen",
	BACK: "Zurück",
	NAVBAR_CLOSE: "Navigation schließen",
	NAVBAR_OPEN: "Navigation öffnen",
};

export default locale;
